<pg-privacy-policy>

  <section id="pg-privacy-policy">
    <h1><u>{ title }</u></h1>

    <div class="content">
    <partial-loading/>
    </div>

  </section>

  <script>
    import './pg-privacy-policy.scss'
    import showdown from 'showdown'
    import PartialLoading from '../components/partial-loading.riot'
    const vlgStrapiUrl = 'https://strapi.vlginvestimentos.com.br'
    let termsAndPolicies

    export default {

      components:{
        PartialLoading
      },
      onMounted() {
        const getData = async() => {
          termsAndPolicies = await fetch(`${vlgStrapiUrl}/terms-and-policies/2`).then(x => x.json())
          const converter = new showdown.Converter()
          this.html = converter.makeHtml(termsAndPolicies.content)
          this.$('.content').innerHTML = this.html
          this.title = termsAndPolicies.title
          this.update()
        }
        getData()
      }
    }

  </script>
</pg-privacy-policy>
